import get from 'lodash/get';

import track from 'Utils/tracking';
import { isLocal, uploadcareUrl } from 'Utils/utils';

import { gaPageView, gaPushEvent } from '../tracking/google-analytics';
import { hubspotPageView } from '../tracking/hubspot';

import { BACKGROUND_UPLOADCARE_OPTIONS, DEFAULT_SIGNUP_BACKGROUND_ID } from './constants';

const pathSite = window.location.pathname.split('/')[1];
export const currentSite = /^t\d\d$/.test(pathSite) ? pathSite : 't01';

const { searchParams } = new URL(window.location.href);
const pricingGroupFromUrl = searchParams.get('pricingGroup');
export const isCommunity = searchParams.get('edition') === 'community';

const originalPath = searchParams.get('original_path');
const utmSource = searchParams.get('utm_source') || '';
const utmMedium = searchParams.get('utm_medium') || '';
const utmCampaign = searchParams.get('utm_campaign') || '';
const utmTerm = searchParams.get('utm_term') || '';
const utmContent = searchParams.get('utm_content');

export const utmParams = {
	utmSource,
	utmCampaign,
	utmMedium,
	utmTerm,
	utmContent,
	originalPath,
};

const PRICING_LOCAL_STORAGE_KEY = 'pricing_group';
export const DEFAULT_ROUTE = 'marketplace';
export const DEFAULT_SIGNUP_EDITION = 'trial';

export const getPricingGroup = () => {
	if (pricingGroupFromUrl) {
		return parseInt(pricingGroupFromUrl, 10);
	}
	const fromLocalStorage = localStorage.getItem(PRICING_LOCAL_STORAGE_KEY);
	if (fromLocalStorage) {
		return parseInt(fromLocalStorage, 10);
	}
	const randomGroup = Math.round(Math.random() + 1) * 1;
	localStorage.setItem(PRICING_LOCAL_STORAGE_KEY, randomGroup);
	return randomGroup;
};

export const uploadToUploadcareFromUrl = (profileImageUrl, setAvatarId) => {
	window.uploadcare.fileFrom('url', profileImageUrl).done(fileInfo => {
		setAvatarId(get(fileInfo, 'uuid'));
	});
};

export const trackExternal = (activeStep, isSuccess) => {
	hubspotPageView(activeStep, isSuccess);
	gaPageView(activeStep, isSuccess);
};

export const onAccountCreatedUtil = (newService, isMobile, handleRedirect, signUpMethod) => {
	track('Signup::Signals', 'Signals');
	trackExternal(null, true);
	gaPushEvent({ stepIndex: null, isSuccess: true, isFreeTrial: !isCommunity, signUpMethod });

	setTimeout(() => {
		if (isMobile()) {
			handleRedirect();
		} else {
			const domain = get(newService, 'user.domain_name');
			const userToken = newService.user['app-token'];
			const baseUrl = isLocal()
				? 'https://localhost:8443'
				: `https://${window.location.host}/${currentSite}/${domain}`;
			window.location.href = `${baseUrl}/loginByToken.html?app-token=${encodeURIComponent(
				userToken,
			)}&route=${DEFAULT_ROUTE}`;
		}
	}, 500);
};

export const getBackgroundStyle = (backgroundImage, windowSize, isTestingBg, backGroundPicture) => {
	if (windowSize.width <= 500) {
		return { backgroundImage: 'unset' };
	}
	if (backgroundImage) {
		return {
			backgroundImage: `url(${uploadcareUrl(backgroundImage, windowSize.width)})`,
		};
	}
	if (isTestingBg) {
		return {};
	}
	return {
		backgroundImage: `url(${uploadcareUrl(
			BACKGROUND_UPLOADCARE_OPTIONS[backGroundPicture] || DEFAULT_SIGNUP_BACKGROUND_ID,
			windowSize.width,
		)})`,
	};
};
